export const INITIAL_FORM = {
  title: '',
  link: '',
  description: '',
  skills: [],
  resourceType: '',
  isGlobal: false,
  ou: '',
  jobFamily: '',
}

export const ONBOARDING_OPTION_ID = 'true'
export const DESCRIPTION_MAX_CHARS = 200

export const ERROR_MESSAGES = {
  title: 'You need to type a title to submit.',
  link: 'You need to paste a link to submit.',
  skills: 'Select at least one skill to submit.',
  resourceType: 'Select one option to submit.',
  ou: 'Select one option to submit.',
}
